import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import AppWithAuth from './AppWithAuth';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createMsalConfig } from './auth/authConfig';

async function bootstrap() {
  try {
    let apiBase = (process.env.REACT_APP_BACKEND_API_URL || '').replace(/\/$/, '');
    if (!apiBase) {
      if (window.location.hostname === 'localhost') {
        apiBase = 'http://localhost:8000';
      } else {
        throw new Error('Missing REACT_APP_BACKEND_API_URL. CI must inject backend URL at build time.');
      }
    }

    const res = await fetch(`${apiBase}/api/config`, { credentials: 'same-origin' });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Failed to fetch config (${res.status}): ${text.slice(0,300)}`);
    }
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      const text = await res.text();
      throw new Error(`Unexpected config response (content-type=${contentType}): ${text.slice(0,300)}`);
    }
    const cfg = await res.json();
    const msalConfig = createMsalConfig(cfg.clientId, cfg.tenantId);
    const msalInstance = new PublicClientApplication(msalConfig);

    try {
      await msalInstance.initialize();
    } catch (initErr) {
      console.warn('MSAL initialization failed:', initErr);
    }

    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <AppWithAuth />
          </MsalProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  } catch (err) {
    console.error('Failed to bootstrap app:', err);
    throw err;
  }
}

bootstrap();

reportWebVitals();
